import axios from "@common/api/desktop/axios";
import { handleDownload } from "@helpers/downloads";

class ReportsClient {
  fetchReports = async () => {
    const response = await axios.get(`Report/ListGroups`);
    return response.data.map((x, index) => {
      return { ...x, id: index + 1 };
    });
  };

  prepareParams = (params) => {
    const missing = 10 - params.length;
    let parsedParams = params.map((x) => (x === null ? "#" : x));

    for (let i = 0; i < missing; i++) {
      parsedParams.push("#");
    }

    return parsedParams.map((item) => encodeURIComponent(item)).join(",");
  };

  getReport = async (reportId, params) => {
    const queryString = this.prepareParams(params);
    const response = await axios.get(
      `Report/Parameters2/${reportId},${queryString}`,
    );
    return response.data;
  };

  createReport = async (reportName, reportId, params) => {
    const queryString = this.prepareParams(Object.values(params));

    await axios
      .get(`Report/Create2/${reportId},${queryString}`, {
        responseType: "arraybuffer",
      })
      .then((response) => handleDownload(response));
  };

  setFavourite = async (id) => {
    const response = await axios.post(`Report/favourites/set`, {
      id,
    });
    return response.data;
  };

  unsetFavourite = async (id) => {
    const response = await axios.post(`Report/favourites/unset`, {
      id,
    });
    return response.data;
  };
}

const instance = new ReportsClient();

export default instance;
